import type { TGuaranteesClientStepKey } from './types.ts';

export const guaranteesClientStepNavigationConfig: ReadonlyArray<{
  key: TGuaranteesClientStepKey;
  title: string;
}> = [
  {
    key: 'step1',
    title: 'Дані заявки',
  },
  {
    key: 'step2',
    title: 'Підписання',
  },
  {
    key: 'step3',
    title: 'Лист-погодження',
  },
];
